import { withStyles } from '@material-ui/core/styles';
import styles from './PricingInfo.styles';
import PricingInfo from './PricingInfo';

export default withStyles(styles)(PricingInfo);
